import { render } from "./Slide1.vue?vue&type=template&id=08e6a94d"
import script from "./Slide1.vue?vue&type=script&lang=js"
export * from "./Slide1.vue?vue&type=script&lang=js"

import "./Slide1.vue?vue&type=style&index=0&id=08e6a94d&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__